import { UUID } from 'crypto'
import License from './License'
import { LicensesUI } from '../../pages/users/model/LicensesUI'
import { VehicleLicenseTypesDto } from '../../pages/users/api/dto/get/VehicleLicenseTypesDto'
import VehicleLicenseTypes from '../vehicle/VehicleLicenseTypes'
import VehicleLicenseType from '../vehicle/VehicleLicenseType'
import { LicenseDto } from '../../pages/users/api/dto/get/LicenseDto'

class Licenses {
  private constructor(licenses: License[]) {
    this.licenses = licenses
  }

  private readonly licenses: License[]

  toLicensesUI(): LicensesUI {
    return {
      licenses: this.licenses.map((license: License) => license.toLicenseUI()),
    } satisfies LicensesUI
  }

  find(licenseId: string): License {
    const license = this.licenses.find((it: License) =>
      it.hadVehicleId(licenseId),
    )

    if (license === undefined) {
      throw Error(`Can't find license with id = ${licenseId}`)
    }

    return license
  }

  getAll(): License[] {
    return this.licenses
  }

  static empty(): Licenses {
    return new Licenses([])
  }

  static fromDto(
    studentId: UUID,
    licensesDto: LicenseDto[],
    vehicleLicensesTypesDto: VehicleLicenseTypesDto,
  ): Licenses {
    const vehicleLicenses = VehicleLicenseTypes.fromDto(vehicleLicensesTypesDto)
    const licenses = vehicleLicenses
      .getAll()
      .map((vehicleLicense: VehicleLicenseType) =>
        License.fromDto(studentId, licensesDto, vehicleLicense),
      )

    return new Licenses(licenses)
  }
}

export default Licenses
